import { createAction } from 'typesafe-actions';

import { Actions as GtmActions } from './constants';

interface UpgradeCtaClickedParams {
  tier: $TSFixMe;
  discountType: $TSFixMe;
  isTrial: $TSFixMe;
}

export const upgradeCtaClicked = createAction(
  GtmActions.UPGRADE_CTA_CLICKED,
  (params: UpgradeCtaClickedParams) => params,
)<UpgradeCtaClickedParams>();
export type UpgradeCtaClickedAction = ReturnType<typeof upgradeCtaClicked>;

interface SignUpClickedParams {
  tier: $TSFixMe;
  discountType: $TSFixMe;
  isTrial: $TSFixMe;
}

export const signUpClicked = createAction(
  GtmActions.SIGN_UP_CLICKED,
  (params: SignUpClickedParams) => params,
)<SignUpClickedParams>();
export type SignUpClickedAction = ReturnType<typeof signUpClicked>;

interface UpgradeDiscountPlanLinkClickedParams {
  tier: $TSFixMe;
  discountType: $TSFixMe;
  isTrial: $TSFixMe;
}

export const upgradeDiscountPlanLinkClicked = createAction(
  GtmActions.UPGRADE_DISCOUNT_PLAN_LINK_CLICKED,
  (params: UpgradeDiscountPlanLinkClickedParams) => params,
)<UpgradeDiscountPlanLinkClickedParams>();
export type UpgradeDiscountPlanLinkClickedAction = ReturnType<
  typeof upgradeDiscountPlanLinkClicked
>;

export const viewPlansClicked = createAction(GtmActions.VIEW_PLANS_CLICKED)();
export type ViewPlansClickedAction = ReturnType<typeof viewPlansClicked>;

export const appStoreLinkClicked = createAction(GtmActions.APP_STORE_LINK_CLICKED)();
export type AppStoreLinkClickedAction = ReturnType<typeof appStoreLinkClicked>;
